<template>
  <div class="originality">
    <div
      class="originality_top"
      :class="{close:!isOpen}"
    >
      <h3 class="top_title">请注意以下审核要点，将帮助你更快通过广告审核</h3>
      <ul class="top_ul">
        <li class="ul_item">1.广告投放内容，包括广告文案、图片、详情页，不得以奖励或其他方式，强制或诱导用户分享或关注公众号；</li>
        <li class="ul_item">2.广告投放内容，包括广告文案、图片、详情页，不得使用“最、第一、必备”等极限词汇或夸大词汇；</li>
        <li class="ul_item">3.根据《反不正当竞争法》要求，有奖销售活动奖品价值最大金额不得超过50000元，如：官方价值超过50000元的汽车（含此类价格汽车的汽车使用权）等；</li>
        <li class="ul_item">4.推广页中，如出现引导用户操作的按钮，按钮文案需与用户实际操作行为保持一致，避免误导用户操作。如果出现不一致情况，则需要在按钮下方进行相应的操作路径解释，解释文案要求清晰可见；</li>
        <li class="ul_item">5.二维码图片在原生推广页内暂无法识别，原生推广页内暂不支持使用二维码。</li>
      </ul>
      <span
        class="switch"
        @click="isOpen = !isOpen"
      >{{ isOpen ? '收起' : '展开' }}</span>
    </div>
    <div class="originality_main">
      <div class="main_titleArea">
        <input
          v-model="creativeinput"
          class="title_input"
          @input="inputcallback"
        >
        <i class="el-icon-edit" />
      </div>
      <div class="main_main">
        <CreativeContent1
          :creativeobj="creativeobj"
          :originality="originality"
          :yuanshengname="yuanshengname"
          @nextStep="$emit('nextStep',$event)"
          @creativecallback="$emit('creativecallback',$event)"
          @jsonyuansheng="$emit('jsonyuansheng',$event)"
          @setyuanshengname="$emit('setyuanshengname',$event)"
        />
      </div>
    </div>
    <div class="but">
      <div>
        <el-button type="primary" @click="$emit('previousStepthree')">上一步</el-button>
      </div>
      <div style="margin-left:795px">
        <el-button type="primary" @click="$emit('submitall')">提交</el-button>
      </div>
    </div>

  </div>
</template>

<script>
// import CreativeContent from './components/creativeContent.vue'
import CreativeContent1 from './components1/Copywriting1.vue'
export default {
  components: {
    // CreativeContent,
    CreativeContent1
  },
  props: {
    originality: {},
    creativeobj: {},
    yuanshengname: {}
  },
  data() {
    return {
      isOpen: true,
      creativeinput: ''// 创意标题文案
    }
  },
  created() {
    this.creativeinput = this.creativeobj.tname// 赋值创意标题文案
  },
  methods: {
    inputcallback() {
      this.$emit('creativeinput', this.creativeinput)
    }
  }
}
</script>

<style scoped lang="less">
.originality {
  position: relative;
  width: 90%;
  margin: 0 auto;
  .originality_top {
    height: 222px;
    position: relative;
    margin-bottom: 24px;
    background-color: #f4f5f7;
    border-radius: 2px;
    box-shadow: inset 0 0 0 1px #d3d4d6;
    transition: height 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
    top: 0;
    left: 0;
    padding: 12px 20px;
    font-size: 13px;
    overflow: hidden;
    &.close {
      height: 41px;
    }
    .top_title {
      margin-bottom: 8px;
    }
    .top_ul {
      margin-bottom: 4px;
      list-style-type: decimal;
      list-style-position: inside;
      color: #24262e;
      line-height: 24px;
      .ul_item {
      }
    }
    .switch {
      position: absolute;
      top: 9px;
      right: 15px;
      cursor: pointer;
      &:hover {
        font-weight: bold;
      }
    }
  }

  .originality_main {
    .main_titleArea {
      .title_input {
        outline: none;
        width: 243px;
        height: 36px;
        background-color: transparent;
        border-radius: 4px;
        padding-left: 10px;
        margin-right: 10px;
        &:hover {
          box-shadow: inset 0 0 0 1px #bec0c2;
        }
      }
    }

    .main_main {
      width: 100%;
    }
  }
}

.but {
 display: flex;
}
</style>
